import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => (
  <div className="max-w-3xl mx-auto px-4 py-24 text-center">
    <div className="font-display text-7xl md:text-8xl font-bold text-saffron-500">404</div>
    <h1 className="font-display text-2xl md:text-3xl font-bold text-bharat-navy mt-3">Calculator not found</h1>
    <p className="text-slate-600 mt-2">This calculator is coming soon or the link is broken.</p>
    <Link to="/">
      <Button className="mt-6 bg-saffron-500 hover:bg-saffron-600 text-white">
        <ArrowLeft className="w-4 h-4 mr-1.5" /> Back to Home
      </Button>
    </Link>
  </div>
);

export default NotFound;
